function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.88 18.172a2.05 2.05 0 1 0 0 4.1 2.05 2.05 0 0 0 0-4.1zm0 3.295a1.245 1.245 0 1 1 0-2.49 1.245 1.245 0 0 1 0 2.49zM6.764 18.172a2.05 2.05 0 1 0 0 4.1 2.05 2.05 0 0 0 0-4.1zm0 3.295a1.245 1.245 0 1 1 0-2.49 1.245 1.245 0 0 1 0 2.49z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 18.173h-.898V14.5c0-2.845-2.328-5.173-5.173-5.173H4.485a2.594 2.594 0 0 0-2.587 2.587v6.259H1v1.203c0 .475.388.862.862.862h2.343a2.275 2.275 0 0 1-.005-.157c0-1.327 1.07-2.402 2.574-2.402 1.504 0 2.534 1.075 2.534 2.402 0 .053-.005.157-.005.157h9c-.038-.21-.005-.104-.005-.157 0-1.327 1.268-2.402 2.595-2.402 1.327 0 2.52 1.075 2.52 2.402 0 .053-.002.105-.006.157h2.73a.865.865 0 0 0 .863-.862v-1.203zm-14.362-5.7H9.854v6.42h2.784v-6.42zm4.131 0h-2.784v6.42h2.784v-6.42zm4.116-1.17h-2.933v3.054h5.987a3.062 3.062 0 0 0-3.054-3.053z"
});

var SvgVan = function SvgVan(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/van.1cabb15b.svg";
export { ForwardRef as ReactComponent };